"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractPlayer = exports.INTERNAL_STATE_CHANGED = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
exports.INTERNAL_STATE_CHANGED = "PLAYER:INTERNAL_STATE_CHANGED";
class AbstractPlayer extends js_player_shared_1.EmitterBaseClass {
    constructor(instanceSettings, initialState = {}) {
        var _a, _b;
        super();
        this.state = Object.assign({}, js_player_shared_1.DefaultPlayerState);
        this.instanceSettings = instanceSettings;
        this.mainContentType = this.isLive() ? js_player_shared_1.ContentType.LIVE : js_player_shared_1.ContentType.VOD;
        const audioOnly = (_b = (_a = this.instanceSettings) === null || _a === void 0 ? void 0 : _a.playResponse) === null || _b === void 0 ? void 0 : _b.audioOnly;
        this.setState(Object.assign({
            contentType: this.mainContentType,
            mediaType: audioOnly ? "audio" : "video",
        }, initialState), false);
    }
    getDefaultPlayerEvent() {
        return {
            currentTime: this.getCurrentTime(),
            duration: this.getDuration(),
            utcCurrentTime: this.getUTCCurrentTime(),
            utcDuration: this.getUTCDuration(),
            seekable: this.getSeekable(),
            utcSeekable: this.getUTCSeekable(),
        };
    }
    isLive() {
        var _a;
        if (((_a = this.instanceSettings.mediaInfo) === null || _a === void 0 ? void 0 : _a.isLive) !== undefined) {
            return this.instanceSettings.mediaInfo.isLive;
        }
        return false;
    }
    setState(state, emit = true) {
        this.state = Object.assign(Object.assign({}, this.state), state);
        emit && this.emit(exports.INTERNAL_STATE_CHANGED, this.state);
    }
    getState() {
        return this.state;
    }
}
exports.AbstractPlayer = AbstractPlayer;
//# sourceMappingURL=AbstractPlayer.js.map